import { z } from '@/libs/zod';

export const customerBalanceSchema = z.object({
  id: z.string(),
  availableForWithdrawal: z.number().min(0).optional(),
  allowPartialWithdrawal: z.boolean().optional(),
  pendingBalance: z.number().min(0).optional(),
  totalBalance: z.number().min(0).optional(),
  name: z.string().optional(),
  socialName: z.string().optional(),
  error: z
    .object({
      code: z.string().optional(),
      message: z.string().optional(),
    })
    .optional(),
});

export type CustomerBalance = z.infer<typeof customerBalanceSchema>;
